module.exports = __webpack_public_path__ + "static/offline-projects-white-638e6ab0f0fca32bdde88ac91815fd04.png";